/**
 * In-memory ring buffer of recent latency samples per service, so the Health
 * page's sparklines fill in as it polls (every 30s). Module-level and
 * intentionally ephemeral — a fresh page load starts empty and builds up; we
 * don't persist because it's a live monitor, not history of record.
 */
const MAX_SAMPLES = 24;
const history = new Map<string, number[]>();

/** Append a latency sample for a service, capping the buffer. */
export function recordLatency(id: string, latencyMs: number): void {
  const series = history.get(id) ?? [];
  series.push(latencyMs);
  if (series.length > MAX_SAMPLES) series.shift();
  history.set(id, series);
}

/** Recent latency samples for a service (oldest → newest); empty if none yet.
 *  Returns a fresh copy so callers get a new reference each poll — a memoized
 *  sparkline would otherwise freeze on the stable in-place array. */
export function getLatencyHistory(id: string): number[] {
  return [...(history.get(id) ?? [])];
}
